export default function urlRedirect(): void {
  // I will get rid of this function once I confirm it's not useful
}
